import { z } from "zod";

const isValidPhoneLength = (val: string): boolean => {
  const clean = val.replace(/\D/g, "");
  return clean.length >= 10 && clean.length <= 15;
};

/**
 * Builds the account profile schema. Platform admins (SUPER_ADMIN /
 * GUESTERIA_ADMIN) have no region profile, so the contact fields (phone,
 * address, languages) are hidden for them — `requireContactFields` relaxes the
 * phone requirement accordingly so the form can still be saved.
 */
export const createAccountProfileSchema = (requireContactFields: boolean) =>
  z.object({
    firstName: z
      .string()
      .trim()
      .min(1, "First name is required")
      .max(30, "Maximum 30 characters is allowed"),
    lastName: z
      .string()
      .trim()
      .min(1, "Last name is required")
      .max(30, "Maximum 30 characters is allowed"),
    email: z
      .string()
      .min(1, "Email is required")
      .email("Please enter a valid email address"),
    phone: requireContactFields
      ? z
          .string()
          .min(1, "Phone number is required")
          .refine(isValidPhoneLength, {
            message: "Phone number must be between 10 and 15 digits",
          })
      : z.string().refine((val) => val === "" || isValidPhoneLength(val), {
          message: "Phone number must be between 10 and 15 digits",
        }),
    address: z.string().optional(),
    language: z.string().optional(),
    preferredLanguage: z.string().optional(),
    photoId: z.string().optional(),
  });

export const accountProfileSchema = createAccountProfileSchema(true);

export type AccountProfileFormData = z.infer<typeof accountProfileSchema>;
